import { NgModule }             from '@angular/core';
import { Http, RequestOptions } from '@angular/http';

import { AuthComponent }        from './auth.component';
import { AuthRoutingModule }    from './auth-routing.module';

import { AuthHttp, AuthConfig } from 'angular2-jwt';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
//   return new AuthHttp(new AuthConfig(), http, options);
    return new AuthHttp(new AuthConfig({
        tokenName: 'id_token',
        tokenGetter: (() => localStorage.getItem('id_token')),
        globalHeaders: [{'Content-Type': 'application/json;charset=utf-8'}],
    }), http, options);
}

@NgModule({
    imports: [
        AuthRoutingModule
    ],
    exports: [],
    declarations: [AuthComponent],
    providers: [
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        }
    ],
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts